define('proprietario-controller',['proprietario-resource'], function() {

    var app = angular.module('proprietario.controller', [
        'proprietario.resource'
    ]);

    app.controller('ProprietarioControllerIndex', ['$scope', '$rootScope', 'Proprietario', '$mdDialog', function($scope, $rootScope, Proprietario, $mdDialog) {
        $scope.usuario = usuario;
        $scope.msgSucess = '';
        $scope.msgError = '';
        $scope.filterProprietario = {};
        $scope.filterProprietario.selectedYear = new Date().getFullYear();
        $scope.filterProprietario.selectedMonth = new Date().getMonth() + 1;

        var getYears = function() {
            year = new Date().getFullYear() - 10;
            var anos = [];
            for (i = 0; i <= 20; i++) {
                anos.push(year + i);
            }
            $scope.anos = angular.copy(anos);
        }
        getYears();

        $scope.$mes = [{
                mes: 1,
                nome: 'Janeiro'
            },
            {
                mes: 2,
                nome: 'Fevereiro'
            },
            {
                mes: 3,
                nome: 'Março'
            },
            {
                mes: 4,
                nome: 'Abril'
            },
            {
                mes: 5,
                nome: 'Maio'
            },
            {
                mes: 6,
                nome: 'Junho'
            },
            {
                mes: 7,
                nome: 'Julho'
            },
            {
                mes: 8,
                nome: 'Agosto'
            },
            {
                mes: 9,
                nome: 'Setembro'
            },
            {
                mes: 10,
                nome: 'Outubro'
            },
            {
                mes: 11,
                nome: 'Novembro'
            },
            {
                mes: 12,
                nome: 'Dezembro'
            },
        ];


        $scope.applyFilter = function() {
            Proprietario.applyFilter($scope.filterProprietario).then(function(r){
                angular.extend($scope, r);
            });
        };
        
        $scope.openComprovantesModal = async function (item) {
            if (item.pagamento.arquivos_comprovantes.length > 0) {
                if (item.pagamento.arquivos_comprovantes.length == 1) {
                    window.location.href = item.pagamento.arquivos_comprovantes[0].link;
                } else {
                    $scope.template = await $rootScope.getTemplate();
                    item.pagamento.pes_nome = item.pes_nome;
                    $mdDialog.show({
                        controller: $scope => $scope.pagamento = item.pagamento,
                        templateUrl: '/site/module/proprietario/public/theme/'+$scope.template+'/view/includes/comprovantes-modal.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: false,
                    });
                };
            } else {
                $scope.status = 'Nenhum comprovante encontrado';
            };
        };

        $scope.openExtrato = function (item) {
            if (item.eexc_file) {
                window.open(item.linkExtrato, '_blank')
            };
        };

    }]);
});

